<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-6",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 6,
      nextPage: '/questionnaire/section1/7',
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Prepare_for_pregnancy.png'),
        mainTitle: 'Are you taking the following dietary supplements?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'None',
              unique: true
            },{
              text: 'Folic acid',
            },{
              text: 'Inositol',
            }
          ]
        ],
        hasInput: true
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
